import { getRescheduleOptions } from "api/appointments";
import { GET_RESCHEDULE_OPTIONS } from "constants/reactQueryKeys";
import { useQuery } from "react-query";

export const useGetRescheduleOptions = (appointmetId) => {
  const { data, isLoading, ...rest } = useQuery(
    [GET_RESCHEDULE_OPTIONS, appointmetId],
    () => getRescheduleOptions(appointmetId),
    {
      enabled: !!appointmetId,
      keepPreviousData: true,
      refetchOnWindowFocus: false,
    }
  );
  return {
    rescheduleOptions: data?.data || null,
    rescheduleOptionsLoading: isLoading,
    ...rest,
  };
};
